/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    CloseButton: {
        id: 'quoteandbind.common.ipid.CloseButton',
        defaultMessage: 'Close'
    },
    IpidInformation: {
        id: 'quoteandbind.common.ipid.IpidInformation',
        defaultMessage: 'Insurance Product Information Document'
    },
    IpidCompany: {
        id: 'quoteandbind.common.ipid.IpidCompany',
        defaultMessage: 'Company: Saga Services Limited'
    },
    IpidCompanyDetails: {
        id: 'quoteandbind.common.ipid.IpidCompanyDetails',
        defaultMessage: 'Saga Services Limited is an insurance intermediary and a wholly owned subsidiary of Saga plc. Registered in England and Wales (Company No. 732602). Registered Office: 3 Pancras Square, London N1C 4AG. Saga Services is authorised and regulated by the Financial Conduct Authority (FCA registered number is 311557).'
    },
    IpidUnderwriterDetails: {
        id: 'quoteandbind.common.ipid.IpidUnderwriterDetails',
        defaultMessage: 'The policy is underwritten by Inter Partner Assistance S.A., which is authorised and regulated by the National Bank of Belgium, with a registered head office at Boulevard du Régent 7, 1000 Brussels, Belgium. Authorised by the Prudential Regulation Authority (firm reference number 202664). Subject to regulation by the Financial Conduct Authority and limited regulation by the Prudential Regulation Authority. Inter Partner Assistance S.A. UK branch office address is 106-118 Station Road, Redhill, RH1 1PR. Inter Partner Assistance S.A. is part of the AXA Group.'
    },
    Product: {
        id: 'quoteandbind.common.ipid.Product',
        defaultMessage: 'Product: '
    },
    WhatIsInsuredHeading: {
        id: 'quoteandbind.common.ipid.WhatIsInsuredHeading',
        defaultMessage: 'What is insured?'
    },
    WhatIsNotInsuredHeading: {
        id: 'quoteandbind.common.ipid.WhatIsNotInsuredHeading',
        defaultMessage: 'What is not insured?'
    },
    AnyRestrictionsHeading: {
        id: 'quoteandbind.common.ipid.AnyRestrictionsHeading',
        defaultMessage: 'Are there any restrictions on cover?'
    },
    WhatCoveredHeading: {
        id: 'quoteandbind.common.ipid.WhatCoveredHeading',
        defaultMessage: 'Where am I covered?'
    },
    ObligationsHeading: {
        id: 'quoteandbind.common.ipid.ObligationsHeading',
        defaultMessage: 'What are my Obligations?'
    },
    HowDoIPayHeading: {
        id: 'quoteandbind.common.ipid.HowDoIPayHeading',
        defaultMessage: 'When and how do I pay?'
    },
    CoverEndStartHeading: {
        id: 'quoteandbind.common.ipid.CoverEndStartHeading',
        defaultMessage: 'When does the cover start and end?'
    },
    CancelContractHeading: {
        id: 'quoteandbind.common.ipid.CancelContractHeading',
        defaultMessage: 'How do I cancel the contract?'
    },
    TermsAndConditionsText: {
        id: 'quoteandbind.common.ipid.TermsAndConditionsText',
        defaultMessage: 'The full terms and conditions of your cover including complete pre-contractual and contractual information can be found in your policy wording and Schedule, please ensure you read all these documents.'
    },
    WhatTypeOfInsuranceHeading: {
        id: 'quoteandbind.common.ipid.WhatTypeOfInsuranceHeading',
        defaultMessage: 'What is this type of insurance?'
    },
    CoverEndStartContent: {
        id: 'quoteandbind.common.ipid.CoverEndStartContent',
        defaultMessage: 'Your cover will start on {startDate} and end on {endDate}.'
    },
    HowToCancelText: {
        id: 'quoteandbind.common.ipid.HowToCancelText',
        defaultMessage: 'You can telephone Saga on {phone} or write to us at Saga Services Limited, PO Box 253, Seaham DO, SR71BN.'
    }
});
